<template lang="html">
  <VuePerfectScrollbar class="main" @settings="scrollSettings">
    <div class="box-main">
    <div class="show-main">
      <div class="name">
        {{message.Al117}}
      </div>
      <div class="box">
        <div class="check-box" :class="opClass.start" v-show="activeName !== 'complete'" style="right: 150px" @click="startAll()">
          <i class="material-icons" style="font-size:20px;float:left">play_arrow</i>
          {{message.Al205}}
        </div>
        <div class="check-box" :class="opClass.stop" v-show="activeName !== 'complete'" style="right: 50px;"  @click="stopAll()">
          <i class="material-icons" style="font-size:20px;float:left">pause</i>
          {{message.Al206}}
        </div>
        <div class="check-box"></div>
        <!-- <el-checkbox class="check-box" v-model="show.floating">{{message.Al179}}</el-checkbox> -->
        <!-- <el-checkbox class="check-box" v-model="checked" @change="moreInfo">{{message.Al133}}</el-checkbox> -->
        <el-badge v-show="completeNum > 0" :value="completeNum" class="complete-item" :style="{left: width}"></el-badge>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="message.Al137" name="upload">
            <div class="upload-box">
              <span class="no-task" v-show="tasks.length === 0&&isOnline"> {{message.Al134}} </span>
              <span class="no-network" v-show="!isOnline"><i class="el-icon-error"></i> {{message.Al220}} </span>
              <comp-file
                :fileClass="filesClass"
                v-for="(task, index) in tasks"
                :key = "task.id"
                :taskType="task.taskType"
                :id="task.id"
                :title="task.title"
                :project="task.project"
                :type="task.type"
                :num ="task.num"
                :percent="task.percent"
                :bitrate="task.bitrate"
                :iconShow="task.iconShow"
                :size="task.size"
                :remainTime="task.remainTime"
                :durationTime="task.durationTime"
                :listType="task.listType"
                :index="index"
                @deleteTaskSuccess="deleteTask(index)"
                @showMore="showInfo(index)"
                :isMore="tasks[chooseIndex]"
                :opEvent='opEvent'
              >
              </comp-file>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="message.Al138" name="download">
            <div class="download-box">
              <span class="no-task" v-show="tasks.length === 0&&isOnline"> {{message.Al135}} </span>
              <span class="no-network" v-show="!isOnline"><i class="el-icon-error"></i> {{message.Al220}} </span>
              <comp-file
                :fileClass="filesClass"
                v-for="(task, index) in tasks"
                :key = "task.id"
                :taskType="task.taskType"
                :id="task.id"
                :title="task.title"
                :project="task.project"
                :type="task.type"
                :percent="task.percent"
                :bitrate="task.bitrate"
                :num ="task.num"
                :iconShow="task.iconShow"
                :size="task.size"
                :remainTime="task.remainTime"
                :durationTime="task.durationTime"
                :listType="task.listType"
                :index="index"
                @deleteTaskSuccess="deleteTask(index)"
                @showMore="showInfo(index)"
                :isMore="tasks[chooseIndex]"
                :opEvent='opEvent'
              >
              </comp-file>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="message.Al139" name="complete">
            <div class="complete-box">
              <span class="no-task" v-show="tasks.length === 0&&isOnline"> {{message.Al136}} </span>
              <span class="no-network" v-show="!isOnline"><i class="el-icon-error"></i> {{message.Al220}} </span>
              <comp-file
                :fileClass="filesClass"
                v-for="(task, index) in tasks"
                :key = "task.id"
                :taskType="task.taskType"
                :id="task.id"
                :title="task.title"
                :project="task.project"
                :type="task.type"
                :percent="task.percent"
                :bitrate="task.bitrate"
                :num ="task.num"
                :com_time="task.com_time"
                :iconShow="task.iconShow"
                :size="task.size"
                :remainTime="task.remainTime"
                :durationTime="task.durationTime"
                :listType="task.listType"
                :index="index"
                @deleteTaskSuccess="deleteTask(index)"
                @showMore="showInfo(index)"
                :isMore="tasks[chooseIndex]"
              >
              </comp-file>

            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="page" v-show="total > 8">
          <el-pagination
            small
            layout="prev, pager, next"
            :page-size="8"
            :total="total"
            :current-page.sync="num"
            @current-change="transferList ()"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="more">
      <comp-info
        :data="tasks[chooseIndex]"
      ></comp-info>
    </div>
  </div>
  </VuePerfectScrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import Store from '@/store'
import _this from '@/main'
import CompFile from '@/app/components/transfer/transferFile.vue'
import CompInfo from '@/app/components/transfer/charts.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  beforeRouteEnter (to, from, next) {
    if (!Store.state.app.login && Store.state.app.login !== null) {
      _this.$app.login(0, response => {
        if (response === 2) {
          _this.$app.start()
        }
      })
    } else {
      next()
    }
  },
  components: {
    CompFile,
    CompInfo,
    VuePerfectScrollbar
  },
  computed: {
    ...mapGetters({
      app: 'app',
      transfer: 'transfer',
      notice: 'notice',
      show: 'show',
      space: 'space'
    })
  },
  watch: {
    'notice.donePkg': function (val) {
      this.completeNum = val
    },
    // 'app.show': function (val) {
    //   if (val) {
    //     this.handleClick()
    //   }
    // },
    'transfer.transferShow.show': function (val) {
      if (val) {
        this.activeName = this.transfer.transferShow.type
        this.$store.dispatch('showApp', true)
      }
    },
    'transfer.aliveList': function () {
      if (this.transfer.aliveList.error !== 0) {
        return
      }
      if (
        this.transfer.aliveList.taskEvents.length === 0 &&
        this.transfer.aliveList.tasks.length === 0
      ) {
        if (this.is) {
          this.transferList()
          this.is = false
        }
      } else {
        this.is = true
        this.transferList()
      }
    },
    'show.floating': function (val) {
      this.$store.dispatch('showFloating', val)
    },
    'space': function () {
      this.setRole()
    }
  },
  data () {
    if (localStorage.getItem('language') === 'en') {
      var width = '258px'
    } else {
      width = '168px'
    }
    if (localStorage.getItem('transferInfo') === 'true') {
      var checked = true
      var filesClass = 'more'
    } else {
      checked = false
      filesClass = ''
    }
    if (localStorage.getItem('completeNum')) {
      var completeNum = parseInt(localStorage.getItem('completeNum'))
    } else {
      completeNum = 0
    }
    return {
      message: {
        Al117: this.$lang.ui.app.l117,
        Al133: this.$lang.ui.app.l133,
        Al134: this.$lang.ui.app.l134,
        Al135: this.$lang.ui.app.l135,
        Al136: this.$lang.ui.app.l136,
        Al137: this.$lang.ui.app.l137,
        Al138: this.$lang.ui.app.l138,
        Al139: this.$lang.ui.app.l139,
        Al179: this.$lang.ui.app.l179,
        Al205: this.$lang.ui.app.l205,
        Al206: this.$lang.ui.app.l206,
        Al220: this.$lang.ui.app.l220
      },
      width: width,
      total: 8,
      num: 1,
      is: true,
      activeName: 'upload',
      tasks: [],
      checked: checked,
      filesClass: filesClass,
      completeNum: completeNum,
      chooseIndex: 0,
      opEvent: '',
      scrollSettings: {
        maxScrollbarLength: 0
      },
      opClass: {
        start: '',
        stop: ''
      },
      isOnline: true
    }
  },
  mounted () {
    this.$store.dispatch('showBox', 'transfer')
    this.setRole()
  },
  methods: {
    setRole () {
      let space = this.space.id
      this.$api.getUserRole(space, response => {
        this.$store.dispatch('addRole', response.permission.role)
      })
    },
    moreInfo () {
      if (this.checked) {
        this.checked = true
        this.filesClass = 'more'
        localStorage.setItem('transferInfo', 'true')
      } else {
        this.checked = false
        this.filesClass = ''
        localStorage.setItem('transferInfo', 'false')
      }
    },
    handleClick () {
      this.chooseIndex = ''
      this.tasks = []
      this.num = 1
      if (this.activeName === 'upload') {
        this.taskList('upload', 0)
      }
      if (this.activeName === 'download') {
        this.taskList('download', 0)
      }
      if (this.activeName === 'complete') {
        this.completeNum = 0
        localStorage.setItem('completeNum', 0)
        this.$store.dispatch('donePkg', 0)
        this.taskList('all', 1)
      }
    },
    transferList () {
      if (this.activeName === 'upload') {
        this.taskList('upload', 0)
      }
      if (this.activeName === 'download') {
        this.taskList('download', 0)
      }
      if (this.activeName === 'complete') {
        this.completeNum = 0
        localStorage.setItem('completeNum', 0)
        this.$store.dispatch('donePkg', 0)
        this.taskList('all', 1)
      }
    },
    taskList (type, finish) {
      var e = {
        taskType: type,
        taskFinish: finish,
        pageNum: this.num,
        pageSize: 8
      }
      this.$app.list(e, response => {
        if (type === 'all') {
          if (this.activeName !== 'complete') {
            return
          }
        } else {
          if (type !== this.activeName) {
            return
          }
        }
        this.isOnline = response !== 1
        // if (response.error === 0) {
        this.total = response.totalNum
        for (var i = response.tasks.length - 1; i >= 0; i--) {
          var fileNum = response.tasks[i].fileNumFile || response.tasks[i].fileNum
          var bitrate = this._global.bandwidthSwitch(response.tasks[i].transfer.bitrate)
          var bps = this._global.bpsSwitch(response.tasks[i].transfer.bitrate)
          var percent = '0%'
          if (response.tasks[i].taskState !== 2) {
            var num = response.tasks[i].transfer.percent
            num = parseInt(num)
            if (num <= 100) {
              percent = num + '%'
            }
          } else {
            percent = '100%'
          }
          if (response.tasks[i].transferFlag === 1) {
            var transferType = 6
          } else if (response.tasks[i].transferFlag === 2) {
            transferType = 7
          } else if (response.tasks[i].transferFlag !== 0) {
            transferType = response.tasks[i].transferFlag + 5
          } else {
            transferType = response.tasks[i].taskState
          }
          if (response.tasks[i].taskType === 0) {
            var taskType = 'upload'
          } else {
            taskType = 'download'
          }
          var size = this._global.trafficSwitch(response.tasks[i].taskSize)
          var remainTime = this._global.timeFormatSwitch(response.tasks[i].transfer.remainTime)
          var durationTime = this._global.timeFormatSwitch(response.tasks[i].transfer.durationTime)
          // if (response.tasks[i].transfer.durationTime === 0) {
          //   var averageBitrate = '0 B/s'
          // } else {
          //   averageBitrate = this._global.calculateBandwidthSwitch(response.tasks[i].transfer.finishSize / response.tasks[i].transfer.durationTime)
          // }
          this.tasks.unshift({
            listType: type,
            id: response.tasks[i].taskId,
            title: response.tasks[i].title,
            num: fileNum,
            project: response.tasks[i].projectName,
            type: transferType,
            taskType: taskType,
            percent: percent,
            bitrate: bitrate,
            bps: bps,
            // averageBitrate: averageBitrate,
            size: size,
            remainTime: remainTime,
            durationTime: durationTime,
            com_time: this._global.timeSwitch(response.tasks[i].taskFinishTime),
            iconShow: {
              iconDelete: true,
              iconStop: true,
              iconStart: true,
              iconTop: true
            }
          })
        }
        this.tasks.length = response.tasks.length
        if (this.chooseIndex === '') {
          this.chooseIndex = 0
        }
        // }
      })
    },
    deleteTask (index) {
      this.tasks.splice(index, 1)
    },
    showInfo (index) {
      if (this.chooseIndex === '') {
        this.chooseIndex = index
      } else {
        if (index !== this.chooseIndex) {
          this.chooseIndex = index
        } else {
          // this.chooseIndex = ''
        }
      }
    },
    stopAll () {
      this.opEvent = 'stop'
      this.opClass.stop = 'set'
      setTimeout(() => {
        this.opEvent = ''
        this.opClass.stop = ''
      }, 1000)
    },
    startAll () {
      this.opEvent = 'start'
      this.opClass.start = 'set'
      setTimeout(() => {
        this.opEvent = ''
        this.opClass.start = ''
      }, 1000)
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  width: 100%;
  overflow: hidden;
  height: 650px;
  background-color: #fff;
}
.box-main {
  width: 100%;
  height: 100%;
  overflow: hidden;
  min-width: 935px;
}
.complete-item {
  position: absolute;
  left: 168px;
  top: 4px;
}
.name {
  position: relative;
  font-size: 16px;
  font-weight: 600;
  padding-left: 10px;
  text-align: left;
  line-height: 60px;
}
.name img {
  position: absolute;
  top: 4px;
  left: 8px;
  width: 28px;
}
.cntrol i {
  float: right;
  font-size: 24px;
  cursor: pointer;
  margin-top: 4px;
}
.cntrol .close:hover {
  font-size: 25px;
}
.main.min {
  left: auto;
  top: auto;
  right: 10px;
  width: 285px;
  bottom: 30px;
}
.main.min .box {
  display: none;
}
.page {
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
}
.check-box {
  z-index: 3;
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 12px;
  height: 20px;
  line-height: 20px;
}
.check-box.set {
  color: #757575;
}
.table-name {
  padding: 2px 4px;
  margin: 4px 0;
  background-color: #fff;
}
.show-main {
  float: left;
  width: calc(100% - 360px);
}
.box {
  z-index: 4;
  position: relative;
  overflow: hidden;
  height: 550px;
  width: 100%;
}
.el-tabs {
  min-width: 560px;
}
.el-tabs__nav {
  position: relative;
  transition: transform .3s;
  float: right;
  margin-right: 10px;
}
.el-tabs__item {
  height: 35px;
}
.no-task {
  font-size: 15px;
  font-style: italic;
  color: #9e9e9e;
}
.upload-box,
.download-box,
.complete-box {
  position: relative;
  padding: 0 10px;
  top: 0;
  height: auto;
  left: 0;
  right: 0;
  width: 100%;
  overflow-y: auto;
}
.el-tab-pane {
  text-align: center;
}
.el-pagination {
  text-align: center;
}
.el-tabs__nav-wrap::after {
  background-color: #fff;
}
.more {
  float: left;
  width: 360px;
  height: 600px;
}
.el-icon-error{
  color: #d43f3a
}
[v-cloak] {
        display: none;
}
.no-network{
  display: inline-block;
  margin-top: 14px;
}
</style>
